import { useQuery, useLazyQuery } from '@apollo/client';
import { useEffect, useState } from 'react';
import { COMBINED_QUERY } from 'processes/Booking/queries/combinedQuery';
import { insurancePackagesDetailedQuery } from 'components/GoodsamInsuranceModal/queries/insurancePackagesDetailedQuery';

export const useCombinedQuery = (rvId, features) => {
  const { data, loading, error, refetch } = useQuery(COMBINED_QUERY, {
    variables: {
      id: rvId,
      for_listing: false,
      features
    },
    fetchPolicy: "no-cache",
    skip: !rvId
  });

  const [insuranceData, setInsuranceData] = useState(null);
  const [insuranceLoading, setInsuranceLoading] = useState(false);
  const [insuranceError, setInsuranceError] = useState(null);
  const [insuranceRequested, setInsuranceRequested] = useState(false);

  const actualRentalType = data?.rvInitialData?.allow_standard_rental ? 1 : 2;

  const [getInsurancePackages] = useLazyQuery(insurancePackagesDetailedQuery, {
    fetchPolicy: "no-cache",
    onCompleted: (result) => {
      if (result?.insurance_packages_detailed?.data) {
        setInsuranceData(result.insurance_packages_detailed.data);
      }
      setInsuranceLoading(false);
    },
    onError: (error) => {
      console.error('Error fetching insurance packages:', error);
      setInsuranceError(error);
      setInsuranceLoading(false);
    }
  });

  useEffect(() => {
    if (data?.rvInitialData && actualRentalType && !insuranceRequested) {
      setInsuranceLoading(true);
      setInsuranceError(null);
      setInsuranceRequested(true);

      getInsurancePackages({
        variables: {
          rv: rvId,
          rental_type: actualRentalType
        }
      });
    }
  }, [data?.rvInitialData, actualRentalType, rvId, getInsurancePackages, insuranceRequested]);

  return {
    rvInitialData: { rv : data?.rvInitialData },
    featureFlagsList: { feature_flags_list: data?.featureFlagsList },
    membershipDetails: { membership_details: data?.membershipDetails },
    insurancePackagesDetailed: insuranceData,
    insuranceLoading: insuranceLoading || !insuranceData,
    error: error || insuranceError,
    refetch
  };
};
